export const textStyles = {}
